import React from 'react';
import classNames from 'classnames';
import styles from './styles.scss';
import { Text } from '@towersystems/towersystems-design-system';

const Name = ({ value, className, ...rest }) => {
    return (<Text>{ value.split('_').join(' ').charAt(0).toUpperCase()+ value.split('_').join(' ').slice(1) } </Text>); 
};

export default Name;
